import React from "react";

// Section Imports
import Header from "./components/sections/Header/Header";
import Hero from "./components/sections/Hero/Hero";
import Carousel from "./components/common/Carousel/Carousel";
import Features from "./components/sections/Features/Features";
import Banks from "./components/sections/Banks/Banks";
// import PoweredBy from "./components/sections/Profile/Profile"
import Industries from "./components/sections/Industries/Industries";
import Testimonials from "./components/sections/Testimonials/Testimonials";
import Advantage from "./components/sections/Advantage/Advantage";
import FAQ from "./components/sections/FAQs/FAQs";
import Footer from "./components/sections/Footer/Footer";

const App = () => {
  return (
    <div>
      {/* Header Section */}
      <Header />

      {/* Hero Section */}
      <Hero />

      {/*Carousel Section */}
      <Carousel />

      {/* Features Section */}
      <Features />

      {/* Advantage Section */}
      <Advantage />

      {/* PoweredBy*/}
      {/* <PoweredBy /> */}

      {/* Banks Section */}
      <Banks />

      {/* Industries Section */}
      <Industries />

      {/* Testimonials Section */}
      <Testimonials />

      {/* FAQs Section */}
      <FAQ />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default App;
